import React from 'react';
import { observer, inject } from 'mobx-react';
import { AvForm } from 'availity-mobx-reactstrap-validation';

import Constraint from 'js/components/Constraint';
import { validatePrice } from 'js/services/Regex';

import Backdrop from 'js/components/core/Backdrop';
import StepStatus from 'js/components/core/SteppedPage/StepStatus';
import ContinueButton, { buttonHeight } from 'js/components/core/SteppedPage/ContinueButton';

import Title from './Title';
import ItemInformation from './ItemInformation';
import TitleInput from './TitleInput';
import MoneyInput from './MoneyInput';
import UploadLink from "js/components/pages/CreatePaymentLinkPage/ItemDetails/UploadLink";
import QtyInput from 'js/components/pages/CreatePaymentLinkPage/ItemDetails/QtyInput';

export default inject('page')(
  observer(({ page }) => {
    const buttonOffset = buttonHeight / 2;
    const contentOffset = !page.hasEnteredPrice ? `${buttonOffset + 1.5}rem` : `${buttonOffset}rem`;
    return (
      <>
        <Backdrop offset={contentOffset}>
          <ItemInformation />
        </Backdrop>

        <Constraint offset={contentOffset}>
          <AvForm onValidSubmit={page.nextDetail}>
            {!page.hasEnteredTitle ? (
              <>
                <Title>What item are you selling?</Title>
                <TitleInput name="title" value={page.title} onChange={page.setTitle} required />
                <ContinueButton delay={0} flat disabled={!page.title.length} />
                <UploadLink to={'/upload-items'}>+ Upload Multiple Items</UploadLink>
              </>
            ) : !page.hasEnteredPrice ? (
              <>
                <Title>What is the price?</Title>
                <MoneyInput
                  name="price"
                  type="number"
                  value={page.price}
                  onChange={page.setPrice}
                  validate={validatePrice}
                  required
                  autoFocus
                />
                <ContinueButton delay={0} flat disabled={!page.price.length} />
              </>
            ) : !page.hasEnteredQuantity ? (
              <>
                <Title>How many do you have?</Title>
                <QtyInput
                  name="quantity"
                  type="number"
                  value={page.quantity}
                  onChange={page.setQuantity}
                  required
                  autoFocus
                />
                <ContinueButton delay={0} flat disabled={!page.quantity.length} />
              </>
            ) : (
              <ContinueButton delay={0} autoFocus />
            )}
          </AvForm>
          <StepStatus />
        </Constraint>
      </>
    );
  }),
);
